import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Dropzone from 'react-dropzone-uploader';

import { Name, Status, Date } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getDynamicForm as onGetDynamicForm,
  addDynamicForm as onaddDynamicForm,
  updateDynamicForm as onUpdateDynamicForm,
  deleteDynamicForm as onDeleteDynamicForm,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import moment from "moment";

//redux
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

const ContactsList = props => {

  //meta title
  document.title = "Mahalleler | Süvari Kurye ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [getEdit, setEdit] = useState();
  const [getIsActive, setIsActive] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [getAnswer, setAnswer] = useState([]);
  const [getPoolID, setPoolID] = useState(null);

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      ilAdi: (getEdit && getEdit.IlAdi) || "",
      ilceAdi: (getEdit && getEdit.IlceAdi) || "",
      zorluk: (getEdit && getEdit.ZorlukKatsayisi) || "",
      lat: (getEdit && getEdit.Latitude) || "",
      long: (getEdit && getEdit.Longitude) || "",
      mahalle : (getEdit && getEdit.MahalleAdi) || "",
    },
    validationSchema: Yup.object({
      ilAdi: Yup.string().required("Lütfen Adınızı Giriniz"),
     
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateUser = {
          ID: getEdit.ID,
          IlAdi: values.ilAdi,
          IlceAdi: values.ilceAdi,
          ZorlukKatsayisi: values.zorluk,
          Latitude: parseFloat(values.lat),
          Longitude: parseFloat(values.long),
          MahalleAdi: values.mahalle,

        };
                console.log("updateUser",updateUser)
        // update user
        dispatch(onUpdateDynamicForm(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          IlAdi: values.ilAdi,
          IlceAdi: values.ilceAdi,
          ZorlukKatsayisi: values.zorluk,
          Latitude: parseFloat(values.lat),
          Longitude: parseFloat(values.long),
          MahalleAdi: values.mahalle,
        //  Pool_Img : getFileName
        };
        // save new user
        dispatch(onaddDynamicForm(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.dynamic,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getEditForm, setEditForm] = useState(false);
  const [getActive, setActive] = useState(false);
  const [getCategoryID, setCategoryID] = useState(false);
  const [getCategory, setCategory] = useState([]);
  const [getFileName, setFileName] = useState(null);



  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
     
      {
        Header: "İlçe Adı",
        accessor: "IlceAdi",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },

       
      {
        Header: "İl Adı",
        accessor: "IlAdi",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
   
      {
        Header: "Mahalle Adı",
        accessor: "MahalleAdi",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
   
      {
        Header: "Zorluk Katsayısı",
        accessor: "ZorlukKatsayisi",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
      

  
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
             

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetDynamicForm());
      setIsEdit(false);
   }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const handleUserClick = arg => {
    const user = arg;
    setEditForm(user)
    setContact(user);
    setIsEdit(true);

    setIsActive(user.Pool_IsActive)
    setCategoryID(user.MainPage_Category_ID)
    setEdit(user)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteDynamicForm(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory= arg => {
    setCategoryID(arg.target.value)
  }

  const [inputs, setInputs] = useState([]);
  const [existingData, setExistingData] = useState(getAnswer);

  // Yeni input ekleme
  const addInput = () => {
    setInputs([...inputs, { id: Math.random().toString(36).substr(2, 9), value: "" }]);
    
  };

  // Input değişimlerini yakalama
  const handleInputChange = (id, value) => {
    setInputs((prev) =>
      prev.map((input) => (input.id === id ? { ...input, value } : input))
    );
  };



  // Yeni eklenen inputları silme
  const deleteInput = (id) => {
    setInputs(inputs.filter((input) => input.id !== id));
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />



      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Mahalleler" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddDynamicForm={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Mahalle Düzenle" : "Mahalle Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">İlçe Adı</Label>
                              <Input
                                name="ilceAdi"
                                type="text"
                                placeholder="İlçe Adı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ilceAdi || ""}
                                invalid={
                                  validation.touched.ilceAdi &&
                                    validation.errors.ilceAdi
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.ilceAdi &&
                                validation.errors.ilceAdi ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ilceAdi}
                                </FormFeedback>
                              ) : null}
                            </div>
                        
                            <div className="mb-3">
                              <Label className="form-label">İl Adı</Label>
                              <Input
                                name="ilAdi"
                                type="text"
                                placeholder="İl Adı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ilAdi || ""}
                                invalid={
                                  validation.touched.ilAdi &&
                                    validation.errors.ilAdi
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.ilAdi &&
                                validation.errors.ilAdi ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ilAdi}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Mahalle Adı</Label>
                              <Input
                                name="mahalle"
                                type="text"
                                placeholder="Mahalle Adı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.mahalle || ""}
                                invalid={
                                  validation.touched.mahalle &&
                                    validation.errors.mahalle
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.mahalle &&
                                validation.errors.mahalle ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.mahalle}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Zorluk Katsayisi</Label>
                              <Input
                                name="zorluk"
                                type="text"
                                placeholder="Zorluk Katsayı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.zorluk || ""}
                                invalid={
                                  validation.touched.zorluk &&
                                    validation.errors.zorluk
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.zorluk &&
                                validation.errors.zorluk ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.zorluk}
                                </FormFeedback>
                              ) : null}
                            </div>

                        
                            <div className="mb-3">
                              <Label className="form-label">Enlem</Label>
                              <Input
                                name="lat"
                                type="text"
                                placeholder="Enlem"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.lat || ""}
                                invalid={
                                  validation.touched.lat &&
                                    validation.errors.lat
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.lat &&
                                validation.errors.lat ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.lat}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Boylam</Label>
                              <Input
                                name="long"
                                type="text"
                                placeholder="Boylam"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.long || ""}
                                invalid={
                                  validation.touched.long &&
                                    validation.errors.long
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.long &&
                                validation.errors.long ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.long}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
